/* WARNING: This file is auto-generated. Do not edit directly.   */
/* To make changes, edit `lib/generators/constants_generator.rb` */
/* To regenerate, run: `rails g constants`                       */

import { ConstantsQuery } from 'queries';

export const FAN = 3;
export const COACH = 4;
export const ATHLETIC_DIRECTOR = 12;

export const FAN_DESCRIPTION = 'Follow teams and games. Select this option if you are not a school or team owner.';
export const COACH_DESCRIPTION = 'Claim and manage your team, live score games, invite users, and more.';
export const ATHLETIC_DIRECTOR_DESCRIPTION = 'Claim and manage your school, invite coaches, and more.';

export type UserTypeType = ConstantsQuery['user_types'][number];

const USER_TYPES: UserTypeType[] = [
  {
    id: FAN,
    name: 'Fan'
  },
  {
    id: COACH,
    name: 'Coach'
  },
  {
    id: ATHLETIC_DIRECTOR,
    name: 'Athletic Director'
  }
];

export default USER_TYPES;
